import React from 'react'
import SectionCards from '../SectionCards'
import styles from './index.module.css'
function BottomHome() {
  return (
    <div className={styles.bottomHome}>
    <SectionCards />
    </div>
  )
}

export default BottomHome